export enum ExecutionContext {
  Mobile = 'mobile',
  Browser = 'browser',
  HybridStorageSharedWorker = 'hybrid-storage-shared-worker',
}
